'use strict';

import header from '../components/header';
import footerTray from '../components/footer-tray';
import headerNavigation from '../components/header-navigation';
import headerSearch from '../components/header-search';
import carousel from '../components/carousel';
import productTiles from '../components/product-tile';

import backdropHelper from '../helpers/backdrop';
import imagesHelper from '../helpers/images';
import viewportHelper from '../helpers/viewport';

import simpleToggle from '../behaviors/simple-toggle';
import focusable from '../behaviors/focusable';

import pageSearch from '../pages/search';
import pageError from '../pages/error';

import analytics from '../analytics';
import dialog from '../dialog';
import page from '../page';
import rating from '../rating';
import util from '../util';
import foundation from '../foundation';
import validator from '../validator';
import tls from '../tls';
import video from '../video';
import newsletter from '../newsletter';
import main from '../main';

import '../jquery-ext';
import '../cookieprivacy';

import product from '../pages/product';
import tutorial from '../pages/tutorial';

import storelocator from '../pages/storelocator';
import content from '../pages/content';
import promotionlanding from '../pages/promotionlanding';
import regimenselector from '../pages/regimenselector';

import module3and4cover from '../components/module3and4imgvideotext';
import marketsampling from '../marketsampling';
import slick from '../slick';

var pages = {
    product,
    tutorial,
    storelocator,
    content,
    promotionlanding,
    regimenselector
};

var viewport_width = $(window).width();

$(window).on('resize', function() {
    //update the window size on screen size change.
    viewport_width = $(window).width();
    $('.vertical-carousel-pageDesigner, .horizontal-slider').slick('resize');

    setTimeout(function() {
        touchDeviceClassForCSS();
    }, 100);
});

pages.search = pageSearch;
pages.error = pageError;

function touchDeviceClassForCSS() {
    if(util.isTouchDevice()) {
        $('body').addClass('touch');
    } else {
        $('body').removeClass('touch');
    }
}

function playVideoHandler() {
	var MAIN_VIDEO_SELECTOR = ".main-video";
	var CAROUSEL_VIDEO_SELECTOR = ".modal-video";
	$(document)
		// main video (inline)
		.on("click", MAIN_VIDEO_SELECTOR, function () {
			var $this = $(this);

			var $inlineEle = $this.parent("div"),
				videoId = $this.data("video-id");

			video.playInline($inlineEle, videoId);
		})

		// carousel videos (launched in modal)
		.on("click", CAROUSEL_VIDEO_SELECTOR, function () {
			var videoId = $(this).data("video-id");

			video.playInModal(videoId);
		});
}

window.app = {
    init: () => {
    	window.sgDialog = dialog;
    	window.sgUtil = util;
        const $ = window.jQuery;
        $(document).foundation();
        main.init();

        // Initialize ES6 Modules
        footerTray.init($);
        header.init($);
        headerNavigation.init($);
        headerSearch.init($, Resources.SIMPLE_SEARCH);
        carousel.init($);
        backdropHelper.init($);
        productTiles.init($);
        imagesHelper.initLazyLoaded($);
        imagesHelper.loadProductImages($);
        viewportHelper.listenForPageEvents($);
        newsletter.init();
        newsletter.pdNewsletterComponent();
        newsletter.footerNewsletter();
        playVideoHandler();
        simpleToggle.init($);
        focusable.init($);
        util.updateWithCsrfInputAjax();//add csrf for post ajax call
        touchDeviceClassForCSS();
        module3and4cover.init();

        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }


        if($('.pt_pagedesigner_storefront').length > 0) {
            if($('.pd-footer').length > 0) {
                $('<li>', {class: 'recommendation-item pdVerticalSlider-item'}).appendTo('.vertical-carousel-pageDesigner');
                $('.pd-footer').appendTo('.pdVerticalSlider-item:last-child');
            }
            function debounce(func, wait, immediate) {
                var timeout;
                return function() {
                    var context = this, args = arguments;
                    var later = function() {
                        timeout = null;
                        if (!immediate) func.apply(context, args);
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) func.apply(context, args);
                };
            };

            // use x and y mousewheel event data to navigate flickity
            function slick_handle_wheel_event(e, slick_instance, homeHeroCarousel_is_animating) {
                // do not trigger a slide change if another is being animated
                if (!homeHeroCarousel_is_animating) {
                    var direction =
                    Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
                    if (direction > 0) {
                        // next slide
                        slick_instance.slick("slickNext");
                    } else {
                        // Do not trigger a slide change when footer content longer and scroll position is not zero
                        if(util.isInViewport($('.pd-footer'))) {
                            if($('.pd-footer-wrapper').scrollTop() <= 0) {
                                slick_instance.slick("slickPrev");
                            }
                        } else {
                            // prev slide
                            slick_instance.slick("slickPrev");
                        }
                    }
                }
            }

            // debounce the wheel event handling since trackpads can have a lot of inertia
            var slick_handle_wheel_event_debounced = debounce( 
                slick_handle_wheel_event
                , 100, true
            );

            // init slider 
            var displayControls = $('.pdVerticalSlider').data('displayControls');
            const homeHeroCarousel = $(".pt_pagedesigner_storefront .vertical-carousel-pageDesigner");

            homeHeroCarousel.slick({
                dots: displayControls,
                vertical: true,
                infinite: false,
                arrows: false,
                verticalSwiping: true,
                responsive: [
                    {
                       breakpoint: 1024,
                       settings: 'unslick'
                    }
                 ]
            });
            var homeHeroCarousel_is_animating = false;

            homeHeroCarousel.on("afterChange", function(index) {
                homeHeroCarousel_is_animating = false;
            });

            homeHeroCarousel.on("beforeChange", function(index) {
                homeHeroCarousel_is_animating = true;
            });

            homeHeroCarousel.on("wheel", function(e) {
                slick_handle_wheel_event_debounced(e.originalEvent, homeHeroCarousel, homeHeroCarousel_is_animating);  
            });
        } else {
            // For PD Vertical Carousel layout component
            $('.vertical-carousel-pageDesigner').on('init', function() {
                var $that = $(this);
                $('.slick-list.draggable', $that).removeAttr('aria-live');
                $('.slick-dots li', $that).each(function(index) {
                    $(this).find('button').attr('aria-label','Display Slide '+(++index) );

                });
            });
            $('.vertical-carousel-pageDesigner').each(function () {
                var slidesToShow = $(this).parent('.pdVerticalSlider').data('slidesToShow');
                var slidesToScroll = $(this).parent('.pdVerticalSlider').data('slidesToScroll');
                var displayControls = $(this).parent('.pdVerticalSlider').data('displayControls');

                $(this).slick({
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    vertical: true,
                    verticalSwiping: true,
                    adaptiveHeight: true,
                    swipe: true,
                    touchMove: true,
                    draggable: true,
                    responsive: [{
                        breakpoint: 600,
                        settings: {
                            slidesToShow: slidesToShow,
                            slidesToScroll: slidesToScroll,
                            infinite: true,
                            dots: displayControls,
                            vertical: true
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            arrows: false,
                            dots: true
                        }
                    }
                    ]
                })
                .on('setPosition', function (event, slick) {
                    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
                });

                // To handle scrolling of carousel on mouse scroll event
                $(this).on('wheel', (function(e) {
                    e.preventDefault();

                    const delta = Math.sign(e.originalEvent.deltaY);
                    if (delta < 0) {
                        $(this).slick('slickPrev');
                    } else {
                        $(this).slick('slickNext');
                    }
                }));
            });
        }

        $('.vertical-carousel-pageDesigner.slick-vertical').on('afterChange', function() {
            setTimeout(function(){
                $('.vertical-carousel-pageDesigner.slick-vertical .slick-slide').each(function() {
                    if ($(this).hasClass('slick-active')) {
                        $(this).find('.component-figure').attr('tabindex', '0');
                    } else {
                        $(this).find('.component-figure').attr('tabindex', '-1');
                    }
                });
            },100);
        });

        $('.horizontal-slider').each(function () {
            var slidesToShow = $(this).parent('.pdSlickSlider').data('slidesToShow');
            var slidesToScroll = $(this).parent('.pdSlickSlider').data('slidesToScroll');

			$(this).slick({
				infinite: false,
				slidesToShow: slidesToShow,
				slidesToScroll: slidesToScroll,
				slide: 'li',
                arrows: true,
				dots: false,
				responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: slidesToShow,
						slidesToScroll: slidesToScroll,
                        arrows: false,
						dots: false
					}
				},
				{
					breakpoint: 769,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						arrows: true,
						dots: false
					}
				},
				{
					breakpoint: 425,
					settings: {
						slidesToShow: 1.5,
						slidesToScroll: 1.5,
						arrows: false,
						dots: false,
                        swipeToSlide: true
					}
				}
				]
			});
		});
        
        // Scroll to top on click of footer logo homepage
        if($('.pt_pagedesigner_storefront').length > 0 && $('.pd-footer a[data-link-label="homepage"]').length > 0) { // If homepage & home link available in footer
            $('.pd-footer a[data-link-label="homepage"]').click(function(e) {
                e.preventDefault();
                if($('.vertical-carousel-pageDesigner').length > 0 && viewport_width >= 1024) { // If there is a verticla carousel
                    $('.vertical-carousel-pageDesigner').slick('slickGoTo', 0);
                } else {
                    $('html, body').animate({ scrollTop: 0}, 'slow');
                }
            });
        }

        // Stop vimeo video onclick of close icon
        var vimeoWrap;
        $('.video-overlay-close').click(function() {
            vimeoWrap = $('#vimeoWrap');
            vimeoWrap.html( vimeoWrap.html() );
         });   

        // Toggle Unmute and mute of vimeo video       
        $(document).ready(function () {
            $(".vimeo--videoPlaceholder").each(function (index) {
                var videoContainer = $(this);
                var iframe = videoContainer.find("iframe");
                var player = new Vimeo.Player(iframe);
        
                videoContainer.data("player", player);
                videoContainer.data("isMuted", true); // Default to muted
        
                var isAutoplay = videoContainer.attr("data-autoplay") === "true"; // Read autoplay setting

                // Disable autoplay from pausing when another video plays
                player.setAutopause(false);

                // If autoplay is disabled, add cursor:pointer
                if (!isAutoplay) {
                    videoContainer.css("cursor", "pointer");
                }

                var muteButton = $(".muteButton").eq(index);
        
                if (muteButton.length === 0) {
                    return;
                }
        
                muteButton.on("click", function () {
                    var isMuted = videoContainer.data("isMuted");
                    player.setMuted(!isMuted).then(function () {
                        videoContainer.data("isMuted", !isMuted);
                        muteButton.toggleClass("is-muted is-unmuted");
                        muteButton.attr("aria-label", isMuted ? "Mute" : "Unmute");
                    });
                });
        
                // Play/Pause Logic (Only if autoplay is disabled)
                if (!isAutoplay) {
                    var eventPlayed = 0;
        
                    function toggleVideoPlayPause() {
                        if (eventPlayed === 0) {
                            player.play();
                            eventPlayed = 1;
                        } else {
                            player.pause();
                            eventPlayed = 0;
                        }
                    }

                    videoContainer.on("click", toggleVideoPlayPause);
                    // ALSO trigger play/pause when clicking of overlay `module3-4`
                    $(".scroll-parrallax-effect-wrapper .module3-4-text-cta").on("click", toggleVideoPlayPause);
                }
            });
        });        
              
        $(document).ready(function() {
            function updatePosition() {
                var windowWidth = $(window).width();
        
                if (windowWidth <= 768) { 
                    // Mobile view: set bottom to 20px
                    $('.homepage_image_video_text_container  .muteButton').css({
                        'position': 'absolute',
                        'top': 'auto',
                        'bottom': '20px'
                    });
                } else {
                    // Desktop view: set top position dynamically
                    var windowHeight = $(window).height(); 
                    var topPosition = Math.max(windowHeight - 60, 0);
                    
                    $('.homepage_image_video_text_container  .muteButton').css({
                        'position': 'absolute',
                        'top': topPosition + 'px',
                        'bottom': 'auto' 
                    });
                }
            }
        
            updatePosition(); 
        
            $(window).on('resize orientationchange', updatePosition);
        });        
        
                
        //Remove viemo video iframe for mobile and desktop as per screen size
        function toggleMuteUnmuteElements() {
            const desktopElements = document.querySelectorAll(".vimeo--videoPlaceholder .d-only-desktop");
            const mobileElements = document.querySelectorAll(".vimeo--videoPlaceholder .d-only-mobile");
        
            if (window.innerWidth <= 768) {
                desktopElements.forEach(el => el.remove());
            } else {
                mobileElements.forEach(el => el.remove());
            }
        }
        
        toggleMuteUnmuteElements();

        $(document).ready(function () {
            const $filterHeadings = $('.filter-heading');
            const $carousels = $('.collection-carousel__main');
            const $carouselMain = $('.wrapper__component');

            let newTopValue = 0;

            if ($(window).width() < 768) {
                var filterHeight = $('.discover-carousel-main .wrapper__component .experience-component:first-child').height();
                
                // Add 24px to the height of filter tabs to avoid overlapping
                newTopValue = filterHeight + 24;
        
                // Set the 'top' property to move the div down with the new height
                $carousels.css('top', newTopValue + 'px');
            }

            function updateCarouselHeight() {
                // Reset height before recalculating
                $carouselMain.height('auto');
            
                const $activeFilter = $('.filter-heading.active');
                const $closestDiscoverSlides = $activeFilter.closest('.filter-articels').find('.discover-slides');
            
                if ($closestDiscoverSlides.length) {
                    let slidesHeight = $closestDiscoverSlides.height();
                    $closestDiscoverSlides.height(slidesHeight);
            
                    // Set new height as slidesHeight
                    let newHeight = slidesHeight;

                    if ($(window).width() < 768) {
                        newHeight = slidesHeight + newTopValue + 48;
                    }
            
                    // Use requestAnimationFrame for better performance
                    requestAnimationFrame(() => {
                        $carouselMain.height(newHeight);
                    });
                    
                }
            }                       
        
            // Initialize slick only on the first visible carousel
            const initSlick = ($slider) => {
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.slick({
                        slidesToShow: 2.6,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true,
                        infinite: false,
                        responsive: [
                            { breakpoint: 1024, settings: { slidesToShow: 2.3 } },
                            { breakpoint: 768, settings: { slidesToShow: 1.3 } }
                        ]
                    });
                } else {
                    $slider.slick('setPosition');
                }
            };
        
            // Show only the first carousel initially
            $carousels.hide().first().show();
            $filterHeadings.first().addClass('active');
            initSlick($carousels.first().find('.experience-slides'));

             // Call the function to update height on initial load
            updateCarouselHeight();

            // Click event for filter headings
            $filterHeadings.on('click', function () {
                if ($(this).hasClass('active')) return;
        
                $filterHeadings.removeClass('active');
                $(this).addClass('active');
        
                $carousels.hide();
                const $currentCarousel = $(this).next('.collection-carousel__main').show();
                initSlick($currentCarousel.find('.experience-slides'));

                // Call the function to update height on filter click
                updateCarouselHeight();

            });
        });        
                                    

        /*backToTopHandler();
        Removing back-to-top as per LUB2-993 - Not in design
        */

        // init specific global components
        analytics.init();

        foundation.init();

        validator.init();
        rating.init();
        video.init();
        marketsampling.init();
        newsletter.newsletterHeader();
        newsletter.isNewsletterEnabled();
        newsletter.newsletterPersistentFooter();
        newsletter.newsletterMobile();
        newsletter.signUpEventListener();
        newsletter.signUpFooter();
        newsletter.footerNewsletter();
        newsletter.newsletterPersistentFooterMobile();

        // execute page specific initializations
        $.extend(page, window.pageContext);

        var ns = page.ns;

        if (ns && pages[ns] && pages[ns].init) {
            pages[ns].init($);
        }

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }

    }
};
// expose global app obj for 3rd party integrations
window.app.user = window.User;
window.app.SCemailUrl = window.Urls.SCemailUrl;
window.app.Product = {};
window.app.tagmanager = analytics.tagmanager;
window.app.gtmInternalPromotion = analytics.gtmInternalPromotion;

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = main.addSummaryScrollbar;


// Initialize Application
$(() => { window.app.init(); });


